module.exports = __webpack_public_path__ + "static/custom-3c7e2a91a9754d7582fb606449dc30b9.jpg";